module.exports = __webpack_public_path__ + "img/code_4ro.2c92e00f.svg";